import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../app/context/cart-context/cart-context";
import { motion } from "framer-motion";

import { BackButton } from "../template/buttons/back-btn/back-btn";
import { CheckoutForm } from "./form/checkout-form";
import { FullName } from "./inputs/full-name";
import { Phone } from "./inputs/phone";
import { Address } from "./inputs/address";
import { OrderComment } from "./inputs/comment";
import { Payments } from "./inputs/payments";
import { CashRadio } from "./inputs/payments/cash-radio";
import { CardRadio } from "./inputs/payments/card-radio";
import { LiqpayRadio } from "./inputs/payments/liqpay-radio";

import './shipping.css';
import ApiServices from "../../service/ApiServices";

export const Shipping = () => {

    const [form, setForm] = useState(false);

    const { clearCart } = useCart();

    const res = new ApiServices()

    const navigate = useNavigate();

    useEffect(() => {
        if (form) {
            const payment = localStorage.getItem('payment');

            if(payment === "cash" || payment === "card") {
                res.createOrder()
                .then(data => {
                    if (data === 'Success') {
                        clearCart();

                        return navigate('/');
                    }
                })  
            } else if (payment === "liqpay") {
                return navigate('/checkout');
            }
            setForm(false);
        }
    },[form])

    const handleCheckoutForm = (data) => {
        setForm(data);
    }

    return (
        <motion.div className="container-fluid"
            initial={{opacity: 0}}
            animate={{opacity: 1, transition: {duration: 0.5}}}
            exit={{opacity: 0, transition: {duration: 0.1}}}
        >
            <BackButton/>
            <div className="row">
                <h2 className="mt-4">Оформлення замовлення</h2>
                <CheckoutForm onCheckoutForm={handleCheckoutForm}>
                    <FullName/>
                    <Phone/>
                    <Address/>
                    <OrderComment/>
                    <Payments>
                        <CashRadio/>
                        <CardRadio/>
                        <LiqpayRadio/>
                    </Payments>
                </CheckoutForm>
            </div>
        </motion.div>
    )
}